<mat-form-field mat-input-height-small>
  <input
    gtm="onTextField"
    gtmAction="Vdd IP Address edit value"
    gtmCategory="diagnosticsPage"
    [gtmOn]="['change', 'focus', 'blur']"
    [(ngModel)]="value"
    (change)="valueChange($event)"
    type="text"
    matInput
    mask="IP"
  />
</mat-form-field>
